import React, {
	useState, useRef, useEffect,
} from 'react';
import CustomIcon from '../../../../Common/CustomIcon/CustomIcon';
import style from './SlotsEditor.module.css';

/**
 * Inline slots editor component for editing slot counts
 * Used by both campaign and backfill content rows
 */
const SlotsEditor = ({
	value, onUpdate, itemId, itemType,
}) => {
	const [ isEditing, setIsEditing, ] = useState(false);
	const [ tempValue, setTempValue, ] = useState(value);
	const inputRef = useRef(null);

	const handleClick = () => {
		setIsEditing(true);
		setTempValue(value);
	};

	const handleBlur = () => {
		setIsEditing(false);
		const newValue = Math.max(0, parseInt(tempValue, 10) || 0);
		if (newValue !== value) {
			onUpdate(itemId, newValue);
		}
	};

	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			handleBlur();
		} else if (e.key === 'Escape') {
			setIsEditing(false);
			setTempValue(value);
		}
	};

	const handleIncrement = () => {
		const newValue = value + 1;
		onUpdate(itemId, newValue);
	};

	const handleDecrement = () => {
		const newValue = Math.max(0, value - 1);
		onUpdate(itemId, newValue);
	};

	useEffect(() => {
		if (isEditing && inputRef.current) {
			inputRef.current.focus();
			inputRef.current.select();
		}
	}, [ isEditing, ]);

	useEffect(() => {
		setTempValue(value);
	}, [ value, ]);

	if (isEditing) {
		return (
			<div className={style.slotsEditorContainer}>
				<input
					ref={inputRef}
					type="number"
					value={tempValue}
					onChange={(e) => {
						return setTempValue(e.target.value);
					}}
					onBlur={handleBlur}
					onKeyDown={handleKeyPress}
					className={style.slotsInput}
					min="0"
				/>
			</div>
		);
	}

	return (
		<div className={style.slotsEditorContainer}>
			<span
				className={style.slotsValue}
				onClick={handleClick}
			>
				{value}
			</span>
			<div className={style.slotsControls}>
				<button
					className={style.slotsButton}
					onClick={handleIncrement}
					data-test-id={`increaseSlotsButton-${itemType}-${itemId}`}
					title="Increase slots"
				>
					<CustomIcon icon="chevron-up" />
				</button>
				<button
					className={style.slotsButton}
					onClick={handleDecrement}
					data-test-id={`decreaseSlotsButton-${itemType}-${itemId}`}
					title="Decrease slots"
				>
					<CustomIcon icon="chevron-down" />
				</button>
			</div>
		</div>
	);
};

export default SlotsEditor;